import IEntryLookup from './entries';
import Hero from '../../components/landingPages/Hero';
import SocialProofOdometer from '../../components/landingPages/SocialProofOdometer';
import Testimonials from '../../components/landingPages/Testimonials';
import Display from '../../components/landingPages/Display';
import Steps from '../../components/landingPages/Steps';
import FAQs from '../../components/landingPages/FAQs';
import Press from '../../components/landingPages/Press';
import SellingOptions from '../../components/landingPages/SellingOptions';

const landingPageEntryLookup: IEntryLookup = {
  block: {
    lpComponentHero: Hero,
    lpComponentPress: Press,
    lpComponentSteps: Steps,
    lpComponentOdometer: SocialProofOdometer,
    lpComponentTestimonials: Testimonials,
    lpComponentSellingOptions: SellingOptions,
    lpComponentDisplay: Display, // This is using a generic display component
    lpComponentModal: FAQs, // Using generic modal component
  },
  inline: {},
};

export default landingPageEntryLookup;
